import * as Config from './config/-APP_TARGET/config';
import * as Default from './config/default';

/* Release */
export const RELEASE_DATE = Config.RELEASE_DATE;
export const RELEASE_VERSION = Config.RELEASE_VERSION;
export const YOUDJ_CORE_VERSION = Config.YOUDJ_CORE_VERSION;

export const TOUCH_ENABLED = (window.navigator.maxTouchPoints > 0 || window.navigator.msMaxTouchPoints > 0);

/* Auth */
export let APP_NAME = Config.APP_NAME;
export const SET_APP_NAME = (value) => { APP_NAME = value }
export let API_NAME = Config.API_NAME;
export const SET_API_NAME = (value) => { API_NAME = value }
export let ACRONYME = Config.ACRONYME;
export const SET_ACRONYME = (value) => { ACRONYME = value }

export let API_URL = Config.API_URL;
export const SET_API_URL = (value) => { API_URL = value }
export let API_CLIENT_ID = Config.API_CLIENT_ID;
export const SET_API_CLIENT_ID = (value) => { API_CLIENT_ID = value }
export let API_IDENTITY_URL = Config.API_IDENTITY_URL;
export const SET_API_IDENTITY_URL = (value) => { API_IDENTITY_URL = value }
export let API_SEARCH_URL = Config.API_SEARCH_URL;
export const SET_API_SEARCH_URL = (value) => { API_SEARCH_URL = value }
export let API_DJAPP_URL = Config.API_DJAPP_URL;
export const SET_API_DJAPP_URL = (value) => { API_DJAPP_URL = value }
export let AUTH_DJAPP_URL = Config.AUTH_DJAPP_URL;
export const SET_AUTH_DJAPP_URL = (value) => { AUTH_DJAPP_URL = value }

export let PARTNERS = Config.PARTNERS;
export const SET_PARTNERS = (value) => { PARTNERS = value }
export let REDIRECT_FORGOT_PASSWORD = Config.REDIRECT_FORGOT_PASSWORD;
export const SET_REDIRECT_FORGOT_PASSWORD = (value) => { REDIRECT_FORGOT_PASSWORD = value }

/* Colors */
export const TYPE_LIGHT = Config.TYPE_LIGHT;
export const TYPE_SECONDARY = Config.TYPE_SECONDARY;
export const TYPE_PLACEHOLDER = Config.TYPE_PLACEHOLDER;
export const TYPE_DARK_SECONDARY = Config.TYPE_DARK_SECONDARY;
export const TYPE_DISABLE = Config.TYPE_DISABLE;
export const BRAND_PRIMARY = Config.BRAND_PRIMARY;
export const BRAND_SECONDARY = Config.BRAND_SECONDARY;
export const BRAND_TERTIARY = Config.BRAND_TERTIARY;
export const GREY_1 = Config.GREY_1;
export const GREY_2 = Config.GREY_2;
export const BLACK_2 = Config.BLACK_2;
export const BLACK_3 = Config.BLACK_3;
export const BLACK_5 = Config.BLACK_5;
export const SYSTEM_BLACK_2 = Config.SYSTEM_BLACK_2;

/* Covers */
export const OLD_IMG = Config.OLD_IMG;
export const DEFAULT_IMG = Config.DEFAULT_IMG;
export const DEFAULT_AVATAR = Config.DEFAULT_AVATAR;
export const DEFAULT_LABEL = Config.DEFAULT_LABEL;

/* Library */
export const MAX_WIDTH = Config.MAX_WIDTH;
export const MAX_HEIGHT_PLAYER = Config.MAX_HEIGHT_PLAYER;
export const COMPACT_HEIGHT_PLAYER = Default.COMPACT_HEIGHT_PLAYER;

export const TAB_BAR_HEIGHT = Config.TAB_BAR_HEIGHT;
export const TAB_BAR_GUTTER = Config.TAB_BAR_GUTTER;

export let RECENT_TRACKS_LIMIT = Config.RECENT_TRACKS_LIMIT;
export const SET_RECENT_TRACKS_LIMIT = (value) => { RECENT_TRACKS_LIMIT = value }

export const LEFT_MENU_CUSTOM_HEIGHT = Config.LEFT_MENU_CUSTOM_HEIGHT;

export const LEFT_PAD_TOP = Config.LEFT_PAD_TOP;
export const CONTENT_PAD = Config.CONTENT_PAD;
export const SIDE_WIDTH = Config.SIDE_WIDTH;
export const SIDE_WIDTH_CLOSE = Config.SIDE_WIDTH_CLOSE;
export const CARD_WIDTH = Config.CARD_WIDTH;
export const CARD_HEIGHT = Config.CARD_HEIGHT;
export const CARD_PAD = Config.CARD_PAD;
export const GRID_PAD = Config.GRID_PAD;
export const SUB_SIDEBAR = Config.SUB_SIDEBAR;
export const GRID_WIDTH = Config.GRID_WIDTH;

export const CHART_PAD = Config.CHART_PAD;
export const CHART_IMAGE_SIZE = Config.CHART_IMAGE_SIZE;
export const FILTERS_PAD = Config.FILTERS_PAD;

export const LIST_ROW_HEIGHT = Config.LIST_ROW_HEIGHT;
export const GUTTER_PREVIEW = Config.GUTTER_PREVIEW;

export const GRID_ROW_HEIGHT = Config.GRID_ROW_HEIGHT;

export const GRID_TREND_ROWS = Config.GRID_TREND_ROWS;
export const GRID_TREND_COLUMNS = Config.GRID_TREND_COLUMNS;
export const GRID_TREND_HEIGHT = Config.GRID_TREND_HEIGHT;

export const GRID_TREND_GENRE_ROWS = Config.GRID_TREND_GENRE_ROWS;
export const GRID_TREND_GENRE_COLUMNS = Config.GRID_TREND_GENRE_COLUMNS;
export const GRID_TREND_GENRE_HEIGHT = Config.GRID_TREND_GENRE_HEIGHT;

export const ARTIST_GRID_WIDTH = Config.ARTIST_GRID_WIDTH;
export const ARTIST_COLUMNS_MAX = Config.ARTIST_COLUMNS_MAX;

export const PLAYLIST_COVER_SIZE = Config.PLAYLIST_COVER_SIZE;
export const DNAV_COVER_SIZE = Config.DNAV_COVER_SIZE;
export const MENU_COVER_SIZE = Config.MENU_COVER_SIZE;
export const TREND_COVER_SIZE = Config.TREND_COVER_SIZE;
export const ARTIST_LABEL_COVER_RELEASE = Config.ARTIST_LABEL_COVER_RELEASE;

export const GRID_COVER_PAD = Config.GRID_COVER_PAD;
export const GRID_COVER_SIZE = Config.GRID_COVER_SIZE;

export const LC_LEFT_PAD = Config.LC_LEFT_PAD;
export const LC_PAD_BETWEEN = Config.LC_PAD_BETWEEN;

export const STICKY_HEADER_HEIGHT = Config.STICKY_HEADER_HEIGHT;

/* MODULES */
export const MOD_TOOLTIPS = Config.MOD_TOOLTIPS;
export const MOD_LINKAGE = Config.MOD_LINKAGE;
export let MOD_PRO = Config.MOD_PRO;
export const SET_MOD_PRO = (state) => { MOD_PRO = state }
export const MOD_FEEDBACK = Config.MOD_FEEDBACK;
/* Party Mode */
export const PARTYMODE = Config.PARTYMODE;
export let PM_URL = Config.PM_URL;
export const SET_PM_URL = (value) => { PM_URL = value }
export let PM_PATH = Config.PM_PATH;
export const SET_PM_PATH = (value) => { PM_PATH = value }
export const PM_MAX_ACTIVES = Config.PM_MAX_ACTIVES;
export const UID_SHARED_PLAYLIST = 1631956376614;
export const UID_SUGGESTED_PLAYLIST = 1646128450965;
/* Iframe - Post Message */
export const IFRAME = Config.IFRAME;
/* Freemium */
export const FREEMIUM = Config.FREEMIUM;
/* Welcome Onboarding */
export const ONBOARDING = Config.ONBOARDING;
/* NOTES / NEWS */
export const MOD_NOTES = Config.MOD_NOTES;
/* POPUPS */
export const POPUPS = Config.POPUPS;
/* Automix */
export const AUTOMIX_ALL = Config.AUTOMIX_ALL;

export const REDIRECT_TRIAL = Config.REDIRECT_TRIAL;

/* FOOTER */
export let F_ABOUT_US = Config.F_ABOUT_US;
export const SET_F_ABOUT_US = (value) => { F_ABOUT_US = value }
export let F_COPYRIGHT = Config.F_COPYRIGHT;
export const SET_F_COPYRIGHT = (value) => { F_COPYRIGHT = value }
export let F_CONTACT = Config.F_CONTACT;
export const SET_F_CONTACT = (value) => { F_CONTACT = value }
export let F_CAREERS = Config.F_CAREERS;
export const SET_F_CAREERS = (value) => { F_CAREERS = value }
export let F_IMAGES = Config.F_IMAGES;
export const SET_F_IMAGES = (value) => { F_IMAGES = value }
export let F_SUPPORT = Config.F_SUPPORT;
export const SET_F_SUPPORT = (value) => { F_SUPPORT = value }
export let F_POLICY = Config.F_POLICY;
export const SET_F_POLICY = (value) => { F_POLICY = value }
export let F_TERMS = Config.F_TERMS;
export const SET_F_TERMS = (value) => { F_TERMS = value }
export let F_FEEDBACK = Config.F_FEEDBACK;
export const SET_F_FEEDBACK = (value) => { F_FEEDBACK = value }
export let F_FEEDBACK_GUEST = Config.F_FEEDBACK_GUEST;
export const SET_F_FEEDBACK_GUEST = (value) => { F_FEEDBACK_GUEST = value }
export let F_LEGAL = Config.F_LEGAL;
export const SET_F_LEGAL = (value) => { F_LEGAL = value }
export let F_REDIRECT_NAME = Config.F_REDIRECT_NAME;
export const SET_F_REDIRECT_NAME = (value) => { F_REDIRECT_NAME = value }
export let F_REDIRECT_URL = Config.F_REDIRECT_URL;
export const SET_F_REDIRECT_URL = (value) => { F_REDIRECT_URL = value }
export let F_FAQ = Config.F_FAQ;
export const SET_F_FAQ = (value) => { F_FAQ = value }
export let F_FAQ_HARDWARE = Config.F_FAQ_HARDWARE;
export const SET_F_FAQ_HARDWARE = (value) => { F_FAQ_HARDWARE = value }
export let F_RELEASE_NOTES = Config.F_RELEASE_NOTES;
export const SET_F_RELEASE_NOTES = (value) => { F_RELEASE_NOTES = value }

/* SOCIALS */
export let S_FACEBOOK = Config.S_FACEBOOK;
export const SET_S_FACEBOOK = (value) => { S_FACEBOOK = value }
export let S_TWITTER = Config.S_TWITTER;
export const SET_S_TWITTER = (value) => { S_TWITTER = value }
export let S_INSTAGRAM = Config.S_INSTAGRAM;
export const SET_S_INSTAGRAM = (value) => { S_INSTAGRAM = value }
export let S_YOUTUBE = Config.S_YOUTUBE;
export const SET_S_YOUTUBE = (value) => { S_YOUTUBE = value }
export let S_TWITCH = Config.S_TWITCH;
export const SET_S_TWITCH = (value) => { S_TWITCH = value }
export let S_TIKTOK = Config.S_TIKTOK;
export const SET_S_TIKTOK = (value) => { S_TIKTOK = value }
export let S_DISCORD = Config.S_DISCORD;
export const SET_S_DISCORD = (value) => { S_DISCORD = value }

/* FUNC / OPTIONS */
export let LIMIT_STRING_CAPITALIZE = Config.LIMIT_STRING_CAPITALIZE;
export const SET_LIMIT_STRING_CAPITALIZE = (state) => { LIMIT_STRING_CAPITALIZE = state }
export let TRENDS_ARTIST_LABEL_MORE = Config.TRENDS_ARTIST_LABEL_MORE;
export const SET_TRENDS_ARTIST_LABEL_MORE = (state) => { TRENDS_ARTIST_LABEL_MORE = state }
export let GENRES_HAS_FAV = Config.GENRES_HAS_FAV;
export const SET_GENRES_HAS_FAV = (state) => { GENRES_HAS_FAV = state }
export let GENRES_HAS_CUSTOM_EMPTY = Config.GENRES_HAS_CUSTOM_EMPTY;
export const SET_GENRES_HAS_CUSTOM_EMPTY = (state) => { GENRES_HAS_CUSTOM_EMPTY = state }
export let ACCESS_STORE = Config.ACCESS_STORE;
export const SET_ACCESS_STORE = (state) => { ACCESS_STORE = state }
export let HAS_FILTER_EXCLUDE = Config.HAS_FILTER_EXCLUDE;
export const SET_HAS_FILTER_EXCLUDE = (state) => { HAS_FILTER_EXCLUDE = state }

/* LIST */
export let SHOW_MIX_NAME = Config.SHOW_MIX_NAME;
export const SET_SHOW_MIX_NAME = (state) => { SHOW_MIX_NAME = state }
export let LIST_HEADER_HAS_REMIXER = Config.LIST_HEADER_HAS_REMIXER;
export const SET_LIST_HEADER_HAS_REMIXER = (state) => { LIST_HEADER_HAS_REMIXER = state }
export let LIST_HAS_MORE = Config.LIST_HAS_MORE;
export const SET_LIST_HAS_MORE = (state) => { LIST_HAS_MORE = state }
export const LIST_NAME_WIDTH = Config.LIST_NAME_WIDTH;

/* GENRES */
export let GENRES_HAS_TRENDING_LABELS = Config.GENRES_HAS_TRENDING_LABELS;
export const SET_GENRES_HAS_TRENDING_LABELS = (state) => { GENRES_HAS_TRENDING_LABELS = state }
export let GENRES_PLAYLISTS_HAS_FILTERS = Config.GENRES_PLAYLISTS_HAS_FILTERS;
export const SET_GENRES_PLAYLISTS_HAS_FILTERS = (state) => { GENRES_PLAYLISTS_HAS_FILTERS = state }
export const GENRES_CUSTOM_EXTRA_SEARCH_SLUG = Config.GENRES_CUSTOM_EXTRA_SEARCH_SLUG;
export let GENRES_HAS_HYPE = Config.GENRES_HAS_HYPE;
export let GENRES_HAS_EXCLUSIVE = Config.GENRES_HAS_EXCLUSIVE;

/* SPLAHSCREEN */
export const HAS_SPLASH = Config.HAS_SPLASH;

export const BANNER_BROWSER_HEIGHT = 48;

/* CART */
export const CART_ENABLE = Config.CART_ENABLE;
export const MAX_CART_ITEMS = 100; // REAL LIMIT 150 BUT SOMETHING WRONG API
export const CART_ITEM_TYPE = Config.CART_ITEM_TYPE;
export const CART_AUDIO_FORMAT = Config.CART_AUDIO_FORMAT;
export const CART_PURCHASE_TYPE = Config.CART_PURCHASE_TYPE;
export const CART_SOURCE_TYPE = Config.CART_SOURCE_TYPE;

export const capAppName = () => APP_NAME.charAt(0).toUpperCase() + APP_NAME.slice(1);
export const capitalize = text => text.split(' ').map( w =>  w.substring(0,1).toUpperCase()+ w.substring(1)).join(' ');
export const limitString = (text, count, isCap = LIMIT_STRING_CAPITALIZE) => {
  return (isCap) ? capitalize(text.toLowerCase()).slice(0, count) + (text.length > count ? "..." : ``) : text.slice(0, count) + (text.length > count ? "..." : ``);
}
export const formatted = x => ({ ...x, ref: `${(x) ? x.id : null}`, selected: false});
export const formattedFromYD = x => ({
  ...x,
  title: x.t,
  label: `Record Label`,
  img: x.i,
  genre: x.g,
  artists: x.a,
  key: `KEY`,
  release: `10/10/20`,
  length: x.d2,
  length_s: x.d1,
  ref: `${x.id}`, selected: false
});
export const rankingByPage = (page, perPage) => (x) => { x.top = ((page - 1) * perPage) + x.top; return x; }
export const formattedFromBP = (x,i) => {
  let tag = ``;
  tag += x.artists.map(artist => `<span class="tag_artist_link" onclick="window.DJAPPMM.goLink('/artists/${artist.slug}/${artist.id}');">${artist.name}</span>`).join(', ');
  if (x.remixers) {
    tag += x.remixers.map((remixer, i) => `${i === 0 ? ` • ` : ``} <span class="tag_artist_link" onclick="window.DJAPPMM.goLink('/artists/${remixer.slug}/${remixer.id}');">${remixer.name}</span>`).join(', ');
  }
  if (x.genre) {
    tag += ` • <span class="tag_genre_link" onclick="window.DJAPPMM.goLink('/genres/${x.genre.slug}');">${limitString(x.genre.name, 20)}</span>`;
  }
  if (x.release && x.release.label) {
    tag += ` • <span class="tag_label_link" onclick="window.DJAPPMM.goLink('/labels/${x.release.label.slug}/${x.release.label.id}');">${limitString(x.release.label.name, 20)}</span>`;
  }

  const resizeImg = (url) => url.replace(`500x500`, `250x250`).replace(`1400x1400`, `250x250`);

  return {
     ...x,
     title: x.name,
     mix_name: (SHOW_MIX_NAME) ?  x.mix_name : ( x.mix_name !== `Original Mix` ? x.mix_name : '' ) ,
     label: (x.release) ? x.release.label.name : '',
     label_id: (x.release) ? x.release.label.id : '',
     label_slug: (x.release) ? x.release.label.slug : '',
     img: (x.release && x.release.image) ? resizeImg(x.release.image.uri) : DEFAULT_IMG,
     waveform: (x.image) ? x.image.uri : null,
     genre_s: (x.genre) ? x.genre.name : '',
     genre: (x.genre) ? x.genre : null,
     artists_s: x.artists.map(artist => artist.name).join(', '),
     remixers_s: ( x.remixers) ? x.remixers.map(remixer => remixer.name).join(', ') : '',
     key: (x.key) ? x.key.name : null,
     key_camelot: (x.key) ? `${x.key.camelot_number}${x.key.camelot_letter}` : null,
     release: x.new_release_date,
     releaseID: (x.release && x.release.id) ? x.release.id : null,
     toStore: (x.release && x.release.slug) ? `https://www.${API_NAME}.com/track/${x.release.slug}/${x.id}` : null,
     length_s: x.length_ms / 1000,
     bpm: (x.bpm) ? x.bpm.toString() : null,
     top: i + 1,
     tag,

     ref: `${x.id}`,
     selected: false
  }
}
export const formattedFromSearchV1 = (x,i) => {
  let tag = ``;
  tag += x.artists.map(artist => `<span class="tag_artist_link" onclick="window.DJAPPMM.goLink('/artists/${formatSlug(artist.artist_name)}/${artist.artist_id}');">${artist.artist_name}</span>`).join(', ');
  tag += x.genre.map(genre => ` • <span class="tag_genre_link" onclick="window.DJAPPMM.goLink('/genres/${formatSlug(genre.genre_name)}');">${limitString(genre.genre_name, 20)}</span>`);
  tag += ` • <span class="tag_label_link" onclick="window.DJAPPMM.goLink('/labels/${formatSlug(x.release.release_name)}/${x.release.release_id}');">${limitString(x.release.release_name, 20)}</span>`;

  const resizeImg = (url) => url.replace(`500x500`, `250x250`).replace(`1400x1400`, `250x250`);

  return {
    artists: x.artists.map(a => ({
      id: a.artist_id,
      image: { id: a.artist_id , uri: null, dynamic_uri: null},
      name: a.artist_name,
      slug: formatSlug(a.artist_name)
    })),
    artists_s: x.artists.map(artist => artist.artist_name).join(', '),
    bpm: (x.bpm) ? x.bpm.toString() : null,
    genre: {
      id: x.genre[0].genre_id,
      name: x.genre[0].genre_name,
      slug: formatSlug(x.genre[0].genre_name),
      url: null
    },
    genre_s: x.genre.map(g => g.genre_name).join(', '),
    id: x.track_id,
    img: (x.release.release_image_uri) ? resizeImg(x.release.release_image_uri) : DEFAULT_IMG,
    is_available_for_streaming: (!!x.is_available_for_streaming),
    key: (x.key_name) ? x.key_name : null,
    key_camelot: (x.key_name) ? x.key_name : null, // missing
    label: x.label.label_name,
    label_id: x.label.label_id,
    label_slug: formatSlug(x.label.label_name),
    length: msToFormatTime(x.length),
    length_s: x.length / 1000,
    length_ms: x.length,
    mix_name: (SHOW_MIX_NAME) ?  x.mix_name : ( x.mix_name !== `Original Mix` ? x.mix_name : '' ) ,
    name: x.track_name,
    new_release_date: x.release_date,
    pre_order: false, // missing
    publish_date: x.publish_date,
    publish_status: x.publish_status,
    release: x.release_date,
    releaseID: (x.release.release_id) ? x.release.release_id : null,
    remixers_s: null, // missing
    remixers: [], // missing
    sample_end_ms: 0, // missing
    sample_start_ms: 0, // missing
    sample_url: null, // missing
    selected: false,
    slug: formatSlug(x.track_name),
    sub_genre: x.sub_genre,
    tag,
    title: x.track_name,
    toStore: (x.track_name) ? `https://www.${API_NAME}.com/track/${formatSlug(x.track_name)}/${x.track_id}` : null,
    top: i + 1,
    url: null, // missing
    waveform: (x.track_image_uri) ? x.track_image_uri : null,
    ref: `${x.track_id}`
  }
}
export const formattedFromCart = (x,i) => {
  const data = formattedFromBP(x.item, i);
  return { ...data, cartItemID: x.id }
};
export const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  if (startIndex <= endIndex) {
    result.splice((endIndex < 0) ? 0 : endIndex, 0, removed);
  } else {
    result.splice(endIndex + 1, 0, removed);
  }
  return result;
}

export const formatSlug = (name) => name.toLowerCase().replaceAll(' ', '-').replaceAll('(', '').replaceAll(')', '').replaceAll('?', '');

export const formattedArtist = x => ({
  id: x.id,
  title: x.name,
  name: x.name,
  forOrder: x.name.toLowerCase(),
  img: (x.image && x.image.uri && !x.image.uri.includes('0dc61986-bccf-49d4-8fad-6b147ea8f327')) ? x.image.uri : DEFAULT_IMG,
  images: [(x.image && x.image.uri && !x.image.uri.includes('0dc61986-bccf-49d4-8fad-6b147ea8f327')) ? x.image.uri : DEFAULT_IMG],
  audio: {
    uri: `/artists/${x.slug ? x.slug : formatSlug(x.name)}/${x.id}`,
  },
  to: `/artists/${x.slug ? x.slug : formatSlug(x.name)}/${x.id}`,
  tracks: 0,
  type: `ARTIST`,
  dragEnabled: false,
  playEnabled: false,
  vote: x.vote ?? 0,
  count: x.count ?? 0
});

export const formattedArtistSearchV1 = x => ({
  id: x.artist_id,
  title: x.artist_name,
  name: x.artist_name,
  forOrder: x.artist_name.toLowerCase(),
  img: (x.artist_image_uri  && !x.artist_image_uri.includes('0dc61986-bccf-49d4-8fad-6b147ea8f327')) ? x.artist_image_uri : DEFAULT_IMG,
  images: [(x.artist_image_uri && !x.artist_image_uri.includes('0dc61986-bccf-49d4-8fad-6b147ea8f327')) ? x.artist_image_uri : DEFAULT_IMG],
  audio: {
    uri: `/artists/${formatSlug(x.artist_name)}/${x.artist_id}`,
  },
  to: `/artists/${formatSlug(x.artist_name)}/${x.artist_id}`,
  tracks: 0,
  type: `ARTIST`,
  dragEnabled: false,
  playEnabled: false,
  vote: x.vote ?? 0,
  count: x.count ?? 0
});

export const formattedLabel = x => ({
  id: x.id,
  title: x.name,
  name: x.name,
  forOrder: x.name.toLowerCase(),
  img: (x.image && !x.image.uri.includes('cda9862c-cf92-4d13-ac65-7e9277181f51')) ? x.image.uri : DEFAULT_IMG,
  images: [(x.image && !x.image.uri.includes('cda9862c-cf92-4d13-ac65-7e9277181f51')) ? x.image.uri : DEFAULT_IMG],
  audio: {
    uri: `/labels/${x.slug ? x.slug : formatSlug(x.name)}/${x.id}`,
  },
  to: `/labels/${x.slug ? x.slug : formatSlug(x.name)}/${x.id}`,
  tracks: 0,
  type: `LABEL`,
  dragEnabled: false,
  playEnabled: false,
  vote: x.vote ?? 0,
  count: x.count ?? 0
});

export const formattedLabelSearchV1 = x => ({
  id: x.label_id,
  title: x.label_name,
  name: x.label_name,
  forOrder: x.label_name.toLowerCase(),
  img: (x.label_image_uri && !x.label_image_uri.includes('cda9862c-cf92-4d13-ac65-7e9277181f51')) ? x.label_image_uri : DEFAULT_IMG,
  images: [(x.label_image_uri && !x.label_image_uri.includes('cda9862c-cf92-4d13-ac65-7e9277181f51')) ? x.label_image_uri : DEFAULT_IMG],
  audio: {
    uri: `/labels/${formatSlug(x.label_name)}/${x.label_id}`,
  },
  to: `/labels/${formatSlug(x.label_name)}/${x.label_id}`,
  tracks: 0,
  type: `LABEL`,
  dragEnabled: false,
  playEnabled: false,
  vote: x.vote ?? 0,
  count: x.count ?? 0
});

export const formattedGenre = x => ({
  id: x.id,
  name: x.name,
  slug: x.slug,
  to: `/genres/${x.slug}/featured`,
  type: `GENRE`,
  vote: x.vote ?? 0
});

export const itemLoading = {
  title: `Loading...`,
  label: `Loading...`,
  img: DEFAULT_IMG,
  genre: { name: `Loading...` },
  artists: [],
  key: `...`,
  release: `...`,
  length_s: 0,
}

export const sortAlpha = (property, asc) => (a, b) => {
  if (a[property] < b[property]) { return (asc) ? -1 : 1 }
  if (a[property] > b[property]) { return (asc) ? 1 : -1 }
  return 0;
}

export const sortNumeric = (property, asc) => (a, b) => {
  const aNumber = parseInt(a[property]);
  const bNumber = parseInt(b[property]);
  if (aNumber < bNumber) { return (asc) ? -1 : 1 }
  if (aNumber > bNumber) { return (asc) ? 1 : -1 }
  return 0;
}

export const sortAlphaNumeric = (property, asc) => (a, b) => {
  const aNumber = parseInt(a[property].slice(0, -1));
  const aLetter = a[property].substr(-1);
  const bNumber = parseInt(b[property].slice(0, -1));
  const bLetter = b[property].substr(-1);
  if (aNumber < bNumber) { return (asc) ? -1 : 1 }
  if (aNumber > bNumber) { return (asc) ? 1 : -1 }
  if (aNumber === bNumber && aLetter < bLetter) { return (asc) ? -1 : 1 }
  if (aNumber === bNumber && aLetter > bLetter) { return (asc) ? 1 : -1 }
  return 0;
}

export const msToFormatTime = (ms) => {
  var minutes = Math.floor(ms / 60000);
  var seconds = ((ms % 60000) / 1000).toFixed(0);
  return minutes + ":" + (seconds < 10 ? '0' : '') + seconds;
}

export const msToTime = (ms) => {
  let hours = Math.floor(ms / (1000 * 60 * 60));
  var minutes = Math.floor((ms / 60000) % 60);
  var seconds = Math.floor((ms % 60000) / 1000);
  return (hours < 10 ? '0' : '') + hours + ':' + (minutes < 10 ? '0' : '') + minutes + ":" + (seconds < 10 ? '0' : '') + seconds;
}

export const msToHourMin = (ms) => {
  let hours = Math.floor(ms / (1000 * 60 * 60));
  var minutes = Math.floor((ms / 60000) % 60);
  return (hours < 10 ? '0' : '') + hours + 'h ' + (minutes < 10 ? '0' : '') + minutes + "m";
}

export const shuffle = (array) => {
  var currentIndex = array.length
    , temporaryValue
    , randomIndex
    ;
  while (0 !== currentIndex) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }
  return array;
}

export const camelCase = (str) => {
  return str.replace(/(\b[a-z](?!\s))/g, (x) => x.toUpperCase() );
}

export let customScroll = (id, top, bottom) => {
  return (e) => {
    // console.log(e.y, top, e.y - top , t , e.y - t)

      if ((e.y / window[`window_zoom`]) - top < 10) {
        if (!window.scrollUp) {
          // console.log(`active scroll UP`, (e.y / window[`window_zoom`]) - top);
          window.scrollUp = setInterval(() => {
            if (document.getElementById(id)) {
              document.getElementById(id).scrollBy(0, -20)
            } else {
              window.clearInterval(window.scrollUp);
              window.scrollUp = null;
            }
          }, 10)
        }
      } else {
        if (window.scrollUp) {
          // console.log(`remove scroll UP`);
          window.clearInterval(window.scrollUp);
          window.scrollUp = null;
        }
      }

      if (bottom - e.y < 20) {
        if (!window.scrollDown) {
          // console.log(`active scroll DOWN`);
          window.scrollDown = setInterval(() => {
            if (document.getElementById(id)) {
              document.getElementById(id).scrollBy(0, 20)
            } else {
              window.clearInterval(window.scrollDown);
              window.scrollDown = null;
            }
          }, 10)
        }
      } else {
        if (window.scrollDown) {
          // console.log(`remove scroll DOWN`);
          window.clearInterval(window.scrollDown);
          window.scrollDown = null;
        }
      }
    }

};
